import React, { } from 'react';
import { fetchGeradorHMTL } from '../../services/products-api';
import { getItemSession } from '../../utils';
import { useState } from 'react';
import { useLanguage } from '../../LanguageContext';
import html2pdf from 'html2pdf.js';
const PDFGenerator = (name) => {
  const [isCartPDF, setIsCartPDF] = useState(true);
  const ukpedido = getItemSession('_pedido').toString();

  const { translations, changeLanguage } = useLanguage();
  
  const parametroControle = {
    "ukPedido": ukpedido
  }

  let ukPedidoJson = JSON.stringify(parametroControle)

  const handlePDF = () => {
  fetchGeradorHMTL(ukPedidoJson)
    .then(result => {
      if (result.data.Data) {
        const blob = new Blob([result.data.Data], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
        
        iframe.onload = () => {
          setTimeout(() => {
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
            URL.revokeObjectURL(url);
          }, 500);
        };
      }
    })
    .catch(error => {
      console.error('Erro:', error);
    });
};

  

  useState(() => {
    if(name.className === 'cart-pdf')
    {
      setIsCartPDF(true)
    } else if (name.className === 'dropdown-pdf')
    {
      setIsCartPDF(false)

    }
  },[])

  const spanClassName = isCartPDF
    ? 'btn btn--cinza btn--block btn--full btn--bold pdf-cotizacao'
    : 'btn btn--cinza pdf-cotizacao-span';

  return (
    <span onClick={handlePDF} className={spanClassName}>
      {translations.PDFGenerator?.Cotizacion}
    </span>
  );
}

export default PDFGenerator;
